(function (app, ng) {

    // ************* Home.ManageUsers.ConfigureUserAccount state is now located on the ManageUsers controller to make user experience better.     
    /*app.config([
        "figModalStateProvider", function (figModalStateProvider) {
            figModalStateProvider.state("Home.ManageUsers.ConfigureUserAccount",
                {
                    url: "/Configure/{userMemberId}",
                    component: "configureUserAccount",
                    resolve: {
                        user: ["userApi", "$stateParams", function (userApi, $stateParams) {
                            return userApi.getTransactionGroupUserMember($stateParams.userMemberId);
                        }],
                        agent: ["user", "agentApi", function (user, agentApi) {
                            return agentApi.getAgentForUserId(user.User.Id).catch(ng.noop);
                        }]             
                        //delegateUser: ["userDelegateApi", function (userDelegateApi) {                          
                        //    return userDelegateApi.getCurrentUserDelegate().catch(ng.noop);
                        //}],
                        //userContext: ["userApi", function (userApi) {
                        //    return userApi.getContextUserIds();
                        //}],
                        //actingUser: [
                        //    "userApi", "userContext", function (userApi, userContext) {
                        //        return userApi.getTransactionGroupUserMemberForUser(userContext.ActingUserId);
                        //}]
                    }
                }, {clickOutsideToClose: false});
        }

    ]);*/

    app.config([
        "figModalStateProvider", function (figModalStateProvider) {
            figModalStateProvider.state("Home.Dashboard.ConfigureAgentAccount",
                {
                    url: "/ConfigureAgentAccount",
                    component: "configureUserAccount",
                    resolve: {
                        user: [
                            "userApi", function (userApi) {
                                return userApi.getCurrentTransactionGroupUserMember();
                            }
                        ],
                        agent: [
                            "agentApi", function (agentApi) {
                                return agentApi.getCurrentAgent().catch(ng.noop);
                            }
                        ],
                        lineOfBusinessCategories: ["lineOfBusinessCategoryApi", function (lineOfBusinessCategoryApi) {
                            return lineOfBusinessCategoryApi.getCategories();
                        }],
                        //delegateUser: [
                        //    "userDelegateApi", function(userDelegateApi) {
                        //        return userDelegateApi.getCurrentUserDelegate().catch(ng.noop);
                        //    }
                        //],
                        //actingUser: [
                        //    "userApi", "userContext", function (userApi, userContext) {
                        //        return userApi.getTransactionGroupUserMemberForUser(userContext.ActingUserId);
                        //    }]
                    }
                }, { clickOutsideToClose: false });
        }
    ]);

    app.component("configureUserAccount",
        {
            controller: configureUserAccountController,
            templateUrl: "/App/Dashboard/ConfigureAgentAccount/template.html",
            bindings: {
                user: "<",
                agent: "<",
                lineOfBusinessCategories: "<"
            }
        });

    configureUserAccountController.$inject = ["$mdDialog", "permissionService", "$state", "disclosureApi", "agentApi", "transactionGroupApi", "_", "$q", "userDelegateApi", "userApi"];

    function configureUserAccountController($mdDialog, permissionService, $state, disclosureApi, agentApi, transactionGroupApi, _, $q, userDelegateApi, userApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    isSaving: false,
                    isClosing: false,
                    isLoading: true,
                    CurrentView: 0
                },
                permissionService: permissionService,
                description: description,
                navigateToBasicInfo: navigateToBasicInfo,
                navigateToDisclosure: navigateToDisclosure,
                navigateToDelegateConfig: navigateToDelegateConfig,
                navigateToOtherSettings: navigateToOtherSettings,
                close: close,
                save: save,
                onSave: onSave
            });

        this.$onInit = function () {
                    

            $ctrl.viewAsUserRoles = [];
            $ctrl.parentUsersUpdated = false;
            userApi.getContextUserIds().then(function (userContext) {
                var getCurrentUserDelegate = userDelegateApi.getCurrentUserDelegate().catch(ng.noop);
                var getTransactionGroupUserMemberForUser = userApi.getTransactionGroupUserMemberForUser(userContext.ActingUserId);

                $q.all([
                    getCurrentUserDelegate, getTransactionGroupUserMemberForUser
                ]).then(function (data) {

                    var delegateUser = data[0];
                    var actingUser = data[1];

                    if (delegateUser) {
                        $ctrl.viewAsUserRoles = delegateUser.Roles;
                        $ctrl.UI.ShowDelegateConfig = false;
                        $ctrl.UI.ShowBasicInfo = false;
                        $ctrl.UI.CurrentView = 1;
                    } else {
                        $ctrl.viewAsUserRoles = actingUser.Roles;
                        $ctrl.UI.ShowDelegateConfig = true;
                        $ctrl.UI.ShowBasicInfo = true;
                    }

                    $ctrl.UI.isLoading = false;
                });
            });
        };

        function navigateToBasicInfo() {
            $ctrl.UI.CurrentView = 0;
        }

        function navigateToOtherSettings() {
            $ctrl.UI.CurrentView = 3;
        }

        function navigateToDisclosure() {
            if (!$ctrl.agent) return;
            //$ctrl.disclosures = [];
            //if ($ctrl.agent.DisclosureIds) {
            //    ng.forEach($ctrl.agent.DisclosureIds,
            //        function (disclosureId) {
            //            agentApi.getAgentDisclosure($ctrl.agent.Id, disclosureId).then(function (response) {
            //                $ctrl.disclosures.push(response);                            
            //        });
            //    });              
            //} 

            $ctrl.UI.CurrentView = 1;
        }

        function navigateToDelegateConfig() {
            $ctrl.UI.CurrentView = 2;
        }

        function description(view) {
            switch (view) {
                case 0: return "Basic Personal and Account Information";
                case 1: return "Manage Account Specific Documents and Disclosures";
                case 2: return "Manage Office Support And Delegates";
                case 3: return "Entity Specific User Settings";
                default: return "";
            }
        }

        function close() {
            $ctrl.UI.isClosing = true;
            //return $mdDialog.hide();         
            if ($ctrl.parentUsersUpdated)
                return $state.go("^", {}, { reload: true });

            return $state.go("^", {}, { reload: false });
        }

        function onSave(func) {
            var onSaveFunc = function () { };
            onSaveFunc = function () {
                $ctrl.UI.isSaving = true;

                return func().then(function () {
                    $ctrl.UI.isSaving = false;
                });
            };
        }

        function save() {
            onSaveFunc();
        }
    }

})(window.app, window.angular); //jshint ignore:line